export type Patch = {
  name: string;
  date: Date;
};

export const PATCHES: Patch[] = [
  {
    name: '2023-02-14',
    date: new Date('2023-02-14'),
  },
  {
    name: '2023-06-27',
    date: new Date('2023-06-27'),
  },
  {
    name: '2023-08-22',
    date: new Date('2023-08-22'),
  },
  {
    name: '2023-09-26',
    date: new Date('2023-09-26'),
  },
{
    name: '2023-11-28',
    date: new Date('2023-11-28'),
  },
{
    name: '2024-03-19',
    date: new Date('2024-03-19'),
  },
  {
    name: '2024-04-16',
    date: new Date('2024-04-16'),
  },
  {
    name: '2025-02-11',
    date: new Date('2025-02-11'),
  },
  {
    name: '2025-04-15',
    date: new Date('2025-04-15'),
  },
];

export function getCurrentPatch(): Patch {
  const currentPatch = PATCHES.find((patch) => patch.date > new Date());
  return currentPatch ? currentPatch : PATCHES[PATCHES.length - 1];
}
